// extracted by mini-css-extract-plugin
export default {"container":"AMwQUc6PDLobQBuds0oG","providerIcon":"u6AEMZ4i0_w_drpvScIf","title":"J7RWZIBdFVIu0yTry1aD","shortTitle":"fxjBnmiTs44eRwtYLRvz","dismissButton":"aJxzxxilLsVjKTMDIKic"};